import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Sidebar.scss';
import LogoS from '../../assets/images/logo_n.png';
import {
  FaUserAlt,
  FaProjectDiagram,
  FaBlogger,
  FaRegEnvelope,
  FaHome,
  FaLinkedin,
  FaGithub,
  FaSkype
} from 'react-icons/fa';
import { BsMedium } from 'react-icons/bs';
import { gaLogEvent } from '../React-GA/GA4Tracking';

const navigationItems = [
  {
    to: '/',
    exact: true,
    className: '',
    ariaLabel: 'Link to home page',
    icon: <FaHome />,
    gaLabel: 'Sidebar Home'
  },
  {
    to: '/about',
    exact: true,
    className: 'about-link',
    ariaLabel: 'Link to about page',
    icon: <FaUserAlt />,
    gaLabel: 'Sidebar About'
  },
  {
    to: '/projects',
    exact: true,
    className: 'projects-link',
    ariaLabel: 'Link to projects page',
    icon: <FaProjectDiagram />,
    gaLabel: 'Sidebar Projects'
  },
  {
    to: '/blogs',
    exact: true,
    className: 'blogs-link',
    ariaLabel: 'Link to blogs page',
    icon: <FaBlogger />,
    gaLabel: 'Sidebar Blogs'
  },
  {
    to: '/contact',
    exact: true,
    className: 'contact-link',
    ariaLabel: 'Link to contact page',
    icon: <FaRegEnvelope />,
    gaLabel: 'Sidebar Contact'
  }
];

const socialLinks = [
  {
    href: 'https://www.linkedin.com/in/nazmus-sakib-developer/',
    ariaLabel: 'Linkedin Url link',
    icon: <FaLinkedin />,
    gaLabel: 'Linkedin'
  },
  {
    href: 'https://github.com/saakeeb',
    ariaLabel: 'Github Url link',
    icon: <FaGithub />,
    gaLabel: 'Github'
  },
  {
    href: 'https://medium.com/@saakeeb',
    ariaLabel: 'Medium Url link',
    icon: <BsMedium />,
    gaLabel: 'Medium'
  },
  {
    href: 'skype:live:saakeeb',
    ariaLabel: 'Skype Url link',
    icon: <FaSkype />,
    gaLabel: 'Skype'
  }
];

const Sidebar = () => {
  const handleNavigationClick = (label) => {
    gaLogEvent('Sidebar Navigation: ', 'logo', label, `${label} Click`);
  };

  const handleSocialLinkClick = (label) => {
    gaLogEvent('Sidebar Navigation: ', 'logo', label, `${label} Media`);
  };

  return (
    <div className="nav-bar">
      <Link
        className="logo"
        to="/"
        onClick={() => handleNavigationClick('Sidebar Logo')}
        aria-label="Link to home page"
      >
        <img className="main-logo" src={LogoS} alt="logo" loading="lazy" />
        <h2>Nazmus</h2>
      </Link>
      <nav>
        {navigationItems.map((item) => (
          <NavLink
            key={item.to}
            exact={item.exact}
            activeclassname="active"
            className={item.className}
            to={item.to}
            aria-label={item.ariaLabel}
            onClick={() => handleNavigationClick(item.gaLabel)}
            end={item.to === '/'}
          >
            {item.icon}
          </NavLink>
        ))}
      </nav>
      <ul>
        {socialLinks.map((media) => (
          <li key={media.href}>
            <a
              target="_blank"
              rel="noreferrer"
              href={media.href}
              aria-label={media.ariaLabel}
              onClick={() => handleSocialLinkClick(media.gaLabel)}
            >
              {media.icon}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
